import {
  Snackbar,
  Alert,
  TextField,
  Typography,
  Box,
  InputAdornment,
  Icon,
} from "@mui/material";
import { useState } from "react";
import PropTypes from "prop-types";

function FileField({ displayName, fieldRef, isOptional, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  // console.log(options);
  const [selectedFile, setSelectedFile] = useState(null);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  async function handleFileChange(event) {
    const file = event.target.files[0];
    const fileKb = Math.round(file.size / 1024);
    if (fileKb > 15000) {
      setErrorMsg("File size cannot exceed 15MB.");
      showFieldError(true);
      return;
    }

    setSelectedFile(await toBase64(file));
  }
  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Typography variant="h6" fontWeight="light" fontSize="small" mb={2}>
        {displayName}
      </Typography>
      <TextField
        inputProps={{
          multiple: false,
          accept:
            "application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf, image/*",
        }}
        placeholder={displayName}
        type="file"
        onChange={(e) => handleFileChange(e)}
        options={options}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>attach_file</Icon>
            </InputAdornment>
          ),
        }}
      />
      <input
        id={`dff_${fieldRef}`}
        type="hidden"
        name={fieldRef}
        value={selectedFile}
      />
    </Box>
  );
}

// Typechecking props
FileField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

FileField.defaultProps = {
  options: null,
};

export default FileField;
